export default "__VITE_ASSET__uJUty3Dx__"